import { baseCMSApi } from '@/shared/api/base-cms-api';
import { CMS_ENDPOINTS } from '@/shared/api/endpoints';
import type { ColumnName } from '@/shared/cms/shared';

const columnNameApi = baseCMSApi
    .enhanceEndpoints({
        addTagTypes: ['ColumnName'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getColumnNameBySlug: build.query<
                ColumnName | null,
                { locale: string; slug: string }
            >({
                query: (params) => ({
                    url: CMS_ENDPOINTS.getColumnName(),
                    method: 'GET',
                    params: {
                        where: {
                            slug: {
                                equals: params.slug,
                            },
                        },
                        locale: params.locale,
                        depth: 1,
                        limit: 1,
                    },
                }),
                transformResponse: (response: unknown): ColumnName | null => {
                    if (typeof response === 'object' && response !== null) {
                        const responseObj = response as Record<string, unknown>;

                        if (
                            Array.isArray(responseObj['docs']) &&
                            responseObj['docs'].length > 0
                        ) {
                            return {
                                id: responseObj['docs'][0].id,
                                title: responseObj['docs'][0].title,
                                slug: responseObj['docs'][0].slug,
                                content: responseObj['docs'][0].content,
                                interpolated_value_description:
                                    responseObj['docs'][0]
                                        .interpolated_value_description,
                                updatedAt: responseObj['docs'][0].updatedAt,
                                createdAt: responseObj['docs'][0].createdAt,
                            } as ColumnName;
                        }

                        return null;
                    }

                    return null;
                },
                providesTags: ['ColumnName'],
            }),
        }),
    });

export const { useGetColumnNameBySlugQuery } = columnNameApi;
